// src/LoginPage.js
import React from 'react';
import { Login, LoginForm } from 'react-admin';
import { Box, Card, CardContent, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CustomLoginForm = props => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: '5vh',
            backgroundImage: 'linear-gradient(135deg, #1a237e 0%, #121858 100%)',
        }}
    >
        <Box
            sx={{
                width: '100%',
                maxWidth: '400px',
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box
                component="img"
                src="/logo.svg"
                alt="SmartLeadAI Logo"
                sx={{
                    width: 260,
                    marginBottom: 4,
                }}
            />
            
            <Typography
                variant="h6"
                component="h1"
                gutterBottom
                sx={{
                    color: '#333333',
                    fontWeight: 600,
                    marginBottom: 3,
                    textAlign: 'center',
                }}
            >
                SmartLeadAI Portal
            </Typography>

            <LoginForm {...props} />

            <Link
                component={RouterLink}
                to="/forgot-password"
                sx={{
                    color: '#E31837',
                    textDecoration: 'none',
                    marginTop: 2,
                    fontWeight: 500,
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                }}
            >
                Forgot your password?
            </Link>
        </Box>
    </Box>
);

const LoginPage = props => (
    <Login
        {...props}
        component={CustomLoginForm}
    />
);

export default LoginPage;
